// Shared error-message extraction for the fapi services. FastAPI reports its own failures under
// `detail` — a string, or a list of validation objects — so that is checked before the `error` key
// the Rails-backed services use.

export const messageFromDetail = (detail) => {
  if (!detail) return null;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
    return messages.length ? messages.join('; ') : null;
  }
  if (typeof detail === 'object') return detail.msg || detail.message || null;
  return null;
};

export const GENERIC_FAPI_ERROR = 'Something went wrong. Please try again.';

// `fallbacks` maps a status to the message used when the server sends nothing usable.
export const errorFrom = (data, error, status, fallbacks = {}) =>
  messageFromDetail(data?.detail) || data?.error || data?.message || error || fallbacks[status] || GENERIC_FAPI_ERROR;
